import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeteringPointService } from '@app/api/dmc';
import { Validator } from '@shared/validators/validator.wrapper';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { FormApiService } from '@app/core/services/form-api.service';
import { AlertService } from '@app/core/services/alert.service';
import { TranslatePipe } from '@ngx-translate/core';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-disconnect',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDateDirective,
  ],
  templateUrl: './disconnect.component.html',
  styleUrl: './disconnect.component.css'
})
export class DisconnectComponent implements HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.disconnectForm.dirty;
  }

  public disconnectForm: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl('', [Validators.required]),
    occurrence: new FormControl('', [Validators.required, Validator.dateGreaterThanOrEqual()]),
  });

  /** ID **/
  public id?: string;

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly formApiService: FormApiService,
    private readonly alertService: AlertService,
  ) {
    this.alertService.open('modal', 'info','meteringpoint.disconnect.disconnectInfo');

  }

  public submit(): void {
    if (this.id) {
      this.disconnectForm.get('meteringPointIdentification')?.setValue(this.id);

      this.formApiService.submit(
        this.disconnectForm,
        (data) => this.meteringPointService.meteringPointDisconnectPut(data),
        {
          successMessage: 'meteringpoint.disconnect.disconnectSuccess',
          closeModal: true,
        }
      )
    }
  }

}
